import type React from "react";
import type { Padding } from "../domain/types";

export const EMAIL_BUILDER_LINK_COLOR_CSS_VAR = "--email-builder-link-color";

export function emailBuilderSpacingStyle(spacing: Padding): React.CSSProperties {
  return {
    paddingTop: spacing.top,
    paddingRight: spacing.right,
    paddingBottom: spacing.bottom,
    paddingLeft: spacing.left,
  };
}

export function emailBuilderLinkColorCssVar(linkColor: string): React.CSSProperties {
  return {
    [EMAIL_BUILDER_LINK_COLOR_CSS_VAR]: linkColor,
  } as React.CSSProperties;
}
